jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Component - Site Navigation
  //###*****   Use with styles /styles/components/site-nav.scss
  //############################################//
  var $siteNav = $('.c-site-nav');
  var $siteNavToggle = $('.js-site-nav--toggle');
  var $siteNavItem = $('.c-site-nav__item');

  function smoothScrollToElementDiv(el, speed, top) {
    var speed = speed || 800;
    var top = top || 60;
    var elementToScrollToID = $(el);
    $('html, body').animate(
      {
        scrollTop: $(elementToScrollToID).offset().top - top,
      },
      speed
    );
  }

  //In menu Dropdown menu
  if ($(window).width() < 992) {
    // Main dropdown
    $('.c-site-nav__dropdown')
      .parent()
      .find('> .c-site-nav__dropdown-submenu-link')
      .on('click', function (e) {
        e.preventDefault();
        var submenu = $(this).parent().children('.c-site-nav__dropdown');
        $(this)
          .parent()
          .siblings()
          .removeClass('is-open')
          .children('.c-site-nav__dropdown')
          .slideUp(200);

        if ($(submenu).is(':hidden')) {
          $(submenu).slideDown(200);
          $(submenu).parent().addClass('is-open');
        } else {
          $(submenu).slideUp(200);
          $(submenu).parent().removeClass('is-open');
        }
      });
  }

  //Add is-active to dropdown menu item
  $siteNavItem.hover(
    function (e) {
      var $this = $(this);
      $this.addClass('is-active');
    },
    function () {
      $(this).removeClass('is-active');
    }
  );

  // const mq = window.matchMedia('(min-width: 992px)');

  // if (mq.matches) {
  //   function getClass(element, startsWith) {
  //     var result = undefined;
  //     $(element.attr('class').split(' ')).each(function () {
  //       if (this.indexOf(startsWith) > -1) result = this;
  //     });
  //     return result;
  //   }

  //   $('.js-page-scroll a').on('click', function (event) {
  //     // Make sure this.hash has a value before overriding default behavior
  //     if (this.hash !== '') {
  //       // Store hash
  //       var hash = this.hash;

  //       // Using jQuery's animate() method to add smooth page scroll
  //       // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
  //       $('html, body').animate(
  //         {
  //           scrollTop: $(hash).offset().top - 0,
  //         },
  //         1000,
  //         function () {
  //           // Add hash (#) to URL when done scrolling (default click behavior)
  //           window.location.hash = hash;
  //         }
  //       );
  //       return false;
  //     } // End if
  //   });

  //   Smooth scroll to divs when using hash links in menu
  //   $(".c-site-nav__link").on("click", function (e) {
  //     e.preventDefault();
  //     var id = $(this).attr("href");
  //     // target element
  //     var $id = $(id);
  //     var top = top || 80;
  //     if ($id.length === 0) {
  //       return;
  //     }
  //     // top position relative to the document
  //     var pos = $id.offset().top - top;

  //     // animated top scrolling
  //     $("body, html").animate({ scrollTop: pos });
  //   });
  // }
});
